import { createRequest, getAccessToken } from './config';

const request = createRequest();

export const ProjectPlan = {
  createProjectPlan: (data) =>
    request.post(`/projectplan`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getProjectPlanById: (id) =>
    request.get(`/projectplan/id/${id}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getProjectPlans: () =>
    request.get("/projectplan", {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  updateProjectPlanById: (id, data) =>
    request.patch(`/projectplan/id/${id}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    })
};

export default ProjectPlan;
